import { createStreamingResponse } from "../../adonis.helpers";
import { ToolCallComplete } from "../../streaming/anthropic-stream-handler.types";
import {
  Message,
  ToolContentBlock,
} from "../../streaming/streaming-message-types";
import { ConversationProvider } from "../provider";

export class AdonisHttpProvider implements ConversationProvider {
  constructor(private readonly sessionId: string) {}

  async createUserStream(
    userText: string,
    _history: Message[]
  ): Promise<Response> {
    return createStreamingResponse(this.sessionId, userText);
  }

  async continueWithToolResults(
    toolResultContent: ToolContentBlock[],
    _history: Message[]
  ): Promise<Response> {
    const payload =
      typeof toolResultContent === "string"
        ? toolResultContent
        : JSON.stringify(toolResultContent);
    return createStreamingResponse(this.sessionId, payload);
  }

  async executeTool(_toolCall: ToolCallComplete): Promise<string> {
    // Intentionally not implemented in HTTP provider (engine-agnostic).
    // Tool execution can be handled by a separate provider or higher-level service.
    return "Tool execution is not implemented in AdonisHttpProvider yet.";
  }
}
